import { render, staticRenderFns } from "./TargetBreakForm.vue?vue&type=template&id=b3edcf3a"
import script from "./TargetBreakForm.vue?vue&type=script&lang=js"
export * from "./TargetBreakForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports